module.exports = __webpack_public_path__ + "img/brand-logo-white.1df3a3f6.svg";